import template from './invoiceTimeEntryModal.html';
import controller from './invoiceTimeEntryModal.controller';

let InvoiceTimeEntryModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-warning animated zoomIn"
};

export default InvoiceTimeEntryModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/InvoiceTimeEntryModal/invoiceTimeEntryModal.component.js